<nav id="main-nav">
    <div id="main-logo">
        <a id="logo-menu" routerLink="/"></a>
    </div>
    <div id="main-menu" (click)="toggleMenu()">
        <a id="main-menu-mobile-button" class="hide-desktop">MENU</a>
        <ul id="main-menu-list" class="hide-not-desktop">
            <li *ngFor="let item of menus | async">
                @if(item.target != '_blank') {
                    <a [routerLink]="item.url">{{item.title}}</a>
                }
                @else {
                    <a [href]="item.url" target="_blank">{{item.title}}</a>
                }
            </li>
        </ul>
    </div> 
</nav>
